module.exports = __webpack_public_path__ + "static/media/beg.565428a5.svg";